import { H1 } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import isEqual from 'react-fast-compare';

import { safelyRender } from '@/utils/safelyRender';

type Props = {
    callToAction?: React.ReactNode;
    className?: string;
    title: React.ReactNode;
};

const PageTitle = ({ callToAction, className, title, ...rest }: Props) => {
    if (!title) {
        return null;
    }
    return (
        <div className="mt-lg flex items-center gap-lg xsMax:my-sm">
            <H1
                className={className}
                data-testid="pageTitle"
                {...rest}
            >
                {typeof title === 'string' ? safelyRender({ html: title }) : title}
            </H1>
            {Boolean(callToAction) && callToAction}
        </div>
    );
};

export default React.memo<Props>(PageTitle, isEqual);
